import * as React from 'react';

import { ILinkProps, Link } from '../link';

export interface ILinkWrapperProps extends ILinkProps {
  notRemoveWrapper?: boolean;
}

export class LinkWrapper extends React.PureComponent<ILinkWrapperProps> {
  public render() {
    const { ref, notRemoveWrapper, children, ...sharedProps } = this.props;
    const isOnlyChildren = !this.props.href && !notRemoveWrapper;
    const hidePointer = !this.props.href && notRemoveWrapper;

    if (isOnlyChildren) {
      return React.Children.only(children);
    }

    return (
      <Link hidePointer={hidePointer} {...sharedProps}>
        {children}
      </Link>
    );
  }
}
